import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMemberOrders } from 'core/actions/ocapi';
import { selectUserIsIdentified } from 'core/selectors/user';
import {
  selectRecentMemberOrdersConfig,
  selectRecentMemberOrdersIsLoading,
  selectRecentMemberOrdersIsLoaded,
} from './selectors';

function RecentMemberOrders() {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const config = useSelector(selectRecentMemberOrdersConfig);
  const isLoading = useSelector(selectRecentMemberOrdersIsLoading);
  const isLoaded = useSelector(selectRecentMemberOrdersIsLoaded);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userIsIdentified && !isLoading && !isLoaded) {
      const { api: { params, options } = {} } = config;
      dispatch(fetchMemberOrders(params, options));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null; // No display aspect yet
}

export default RecentMemberOrders;
